import PropTypes from 'prop-types';
import React from 'react';

import { ModalService } from '@sm360/widget-commons-general';

import { VEHICLEVIDEO as MODAL } from 'build-and-quote/constants/modalNames.js';
import VehicleVideoModal from 'build-and-quote/components/Summary/components/VehicleVideo/VehicleVideoModal.jsx';

const modal = ModalService.get(MODAL);

class VehicleVideoRender extends React.PureComponent {
    constructor(props) {
        super(props);

        this.modal = modal;
    }

    render() {
        const modalStyles = {
            overlay: {
                zIndex: 9999,
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
            },
            content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                width: '90%',
                height: '90%',
                padding: '0',
                overflow: 'visible',
                maxHeight: '500px',
                maxWidth: '890px',
                border: '0',
                backgroundColor: 'rgba(255, 255, 255, 1)',
            },
        };

        const modalOptions = {
            contentLabel: 'videoModal section dialog',
            style: modalStyles,
            shouldCloseOnOverlayClick: true,
        };
        const props = {
            ...this.props,
            ...this.state,
        };
        return <VehicleVideoModal {...props} modal={modalOptions} />;
    }
}

VehicleVideoRender.propTypes = {
    videoURL: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
};

VehicleVideoRender.displayName = 'VehicleVideoRender';

export default VehicleVideoRender;
